module.exports = __webpack_public_path__ + "img/u16.d0aef216.png";